import React, { Fragment, useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { updateMass } from '../../../common/api';
import { toast } from 'react-toastify';
import { formatDate } from '../../../common/utils';

import '../modals.css';

const TaskStatusChange = ( { close, user, tids, pStatus } ) => {
    const [ status, setStatus ] = useState();
    const [ outcome, setOutcome ] = useState();
    const [ ready, setReady ] = useState( false );
    const [ processing, setProcessing ] = useState( false );

    const handleUpdate = async () => {
        setProcessing( true );
        
        const updated = await updateMass( user.email, 'mass-tasks', tids, { status: status, outcome: outcome } );
        if ( updated.length ) {
            toast.success( `Tasks have been updated`, { theme: 'dark' } );
            close();
        } else {
            toast.error( `Tasks were not updated - please contact the Support Team`, { theme: 'dark' } );
            setProcessing( false );
        }
    }

    useEffect( () => {
        if ( status && status.length > 0 ) {
            setReady( true );
        } else {
            setReady( false );
        }
    }, [ status ] );

    useEffect( () => {
        if ( !ready ) {
            setStatus( pStatus.find( p => p.default ).value );
        }
    }, [ ready, pStatus ] );

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '600px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Status Change for Selected Tasks</Col>
                </Row>
                {
                    processing ? (
                        <Fragment>
                            <Row className='py-3'>
                                <Col className='text-center'>
                                    <Spinner animation="border" variant='primary' role="status" />
                                </Col>
                            </Row>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>New Status for These Tasks</Form.Label>
                                        <Form.Select size='sm' className='tf-modal-text-input' value={status} onChange={ ( e ) => setStatus( e.target.value ) }>
                                            {
                                                pStatus.map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Completion Notes</Form.Label>
                                        <Form.Control as='textarea' rows={3} className='tf-modal-text-input' placeholder="Specific details..." value={outcome} onChange={ ( e ) => setOutcome( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => handleUpdate() } disabled={!ready}>Update</Button>
                                </Col>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => close() }>Cancel</Button>
                                </Col>
                            </Row>
                        </Fragment>
                    )
                }
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    user: state.user,
    pStatus: state.user.meta.task.picklist.status
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( TaskStatusChange );